import { Link } from 'react-router-dom'
import { Facebook, Instagram, Twitter } from 'lucide-react'

const menuLinks = [
  { label: 'Сургалт', to: '/courses' },
  { label: 'Багш нар', to: '/teachers' },
  { label: 'Видео контент', to: '/videos' },
  { label: 'Нийтлэл', to: '/feed' },
]

const supportLinks = [
  { label: 'Тусламж', to: '/help' },
  { label: 'Нууцлалын бодлого', to: '/privacy' },
  { label: 'Үйлчилгээний нөхцөл', to: '/terms' },
  { label: 'Холбоо барих', to: '/contact' },
  { label: 'EULA', to: '/eula' },
]

const socialLinks = [
  { label: 'Facebook', icon: Facebook, href: 'https://facebook.com/www.arya.mn' },
  { label: 'Instagram', icon: Instagram, href: '#' },
  { label: 'Twitter', icon: Twitter, href: '#' },
]

export default function Footer() {
  return (
    <footer className="bg-gray-100 border-t border-gray-300">
      <div className="max-w-[1024px] mx-auto pt-10 md:pt-[60px] px-4">
        {/* Top section */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-8">
          {/* Left column */}
          <div className="w-full md:w-[400px]">
            {/* Logo */}
            <Link to="/" className="flex items-center mb-4">
              <img src="/logo.png" alt="ARYA" className="h-11" />
            </Link>

            {/* Description */}
            <p className="text-base md:text-lg text-gray-600 font-small mb-6">
              ARYA бол таны оюун мэдлэгийг тэтгэх, шашны боловсролыг орчин
              үеийн арга барилаар олгох онлайн платформ юм.
            </p>

            {/* Social links */}
            <div className="flex gap-3 flex-wrap">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="flex items-center gap-2 border border-gray-300 rounded-lg px-3 py-2 text-gray-500 hover:text-gray-700 hover:border-gray-400 transition"
                >
                  <social.icon className="w-4 h-4" />
                  <span className="text-sm font-medium">{social.label}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Right columns */}
          <div className="flex gap-6 sm:gap-12">
            {/* ЦЭС column */}
            <div>
              <h4 className="font-bold text-gray-800 mb-4">ЦЭС</h4>
              <ul className="space-y-3">
                {menuLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-gray-500 font-medium hover:text-gray-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* ХОЛБОГДОХ column */}
            <div>
              <h4 className="font-bold text-gray-800 mb-4">ХОЛБОГДОХ</h4>
              <ul className="space-y-3">
                {supportLinks.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-gray-500 font-medium hover:text-gray-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-300 py-8 md:py-14 mt-10 md:mt-[76px] flex flex-col sm:flex-row justify-between items-center gap-2">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-success-500 inline-block" />
            <span className="text-sm text-gray-400">
              © 2026 ARYA Platform. Бүх эрх хуулиар хамгаалагдсан.
            </span>
          </div>
          <span className="text-sm text-gray-400 italic">
            Ulaanbaatar, Mongolia 2026
          </span>
        </div>
      </div>
    </footer>
  )
}
